import { useState } from "react"
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance"
import { DISCOUNTS_API } from "../../../../Utilities/APIs/APIs"
import Form from "../../../Partials/Layouts/Forms/Form"
import ShortTextInput from "../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput"
import SwitchInput from "../../../Partials/Layouts/Forms/FormInputs/SwitchInput/SwitchInput"
import FormSubmitButton from "../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton"

function CreateDiscount({

    employee, setShowCreateForm, setShowModal, triggerFetch

}) {

   const [amount, setAmount] = useState(0)
   const [isApplicable, setIsApplicable] = useState(false)
  
    const axiosInstance = useAxiosInstance()

    async function handleSubmit(e) {
        e.preventDefault()
        const itemData = new FormData()

        itemData.append('amount', amount)
        itemData.append('isApplicable', isApplicable)
   
    

        const response = await axiosInstance.post(DISCOUNTS_API, itemData)

        if (response) {

            setShowCreateForm(false);
            setShowModal(false);
            triggerFetch()
        }

    }

    return (
        <Form onSubmit={handleSubmit} hasImage>

            <ShortTextInput
                label= "amount"
                placeholder='Enter amount'
                value={amount}
                setState={setAmount}

            />
            <ShortTextInput
                label= "Is Applicable"
                placeholder='Enter description'
                value={isApplicable}
                setState={setIsApplicable}

            />
             <SwitchInput
                label={'Is Applicable'}
                toggleSwitch={() => setIsApplicable(prevState => !prevState)}
                checked={isApplicable}
            />

            <FormSubmitButton text='Create Discount' />
        </Form>
    )
}

export default CreateDiscount